import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyTables } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./SubAdminPage.css";

const ROLES = ["Support", "KYC", "Finance", "Trading"];

const SubAdminPage = () => {
  const [subAdmins, setSubAdmins] = useState(
    dummyTables.listsubadmin.rows.map((r, i) => ({
      ...r,
      id: `sub_${i}`,
      roles: r.roles || (r.role ? [r.role] : ["Support"]),
    }))
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [viewAdmin, setViewAdmin] = useState(null);
  const [editAdmin, setEditAdmin] = useState(null);
  const [form, setForm] = useState({
    name: "",
    email: "",
    roles: ["Support"],
    password: "",
    confirmPassword: "",
    status: "Active",
  });
  const [error, setError] = useState("");

  const columns = [
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "roles", label: "Roles" },
    { key: "status", label: "Status" },
    { key: "created", label: "Created" },
    { key: "actions", label: "Actions" },
  ];

  const getRolesDisplay = (row) => {
    const roles = row.roles || (row.role ? [row.role] : []);
    return Array.isArray(roles) ? roles.join(", ") : String(roles);
  };

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => {
    setModalOpen(false);
    setForm({
      name: "",
      email: "",
      roles: ["Support"],
      password: "",
      confirmPassword: "",
      status: "Active",
    });
    setError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (!form.name.trim() || !form.email.trim()) {
      setError("Name and Email are required.");
      return;
    }
    if (!form.password) {
      setError("Password is required.");
      return;
    }
    if (form.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    if (!form.roles || form.roles.length === 0) {
      setError("Select at least one role.");
      return;
    }
    setSubAdmins((prev) => [
      ...prev,
      {
        id: `sub_${Date.now()}`,
        name: form.name.trim(),
        email: form.email.trim(),
        roles: [...form.roles],
        status: form.status,
        created: new Date().toISOString().slice(0, 10),
      },
    ]);
    handleCloseModal();
  };

  const handleBlockToggle = (admin) => {
    setSubAdmins((prev) =>
      prev.map((a) =>
        a.id === admin.id
          ? { ...a, status: a.status === "Active" ? "Inactive" : "Active" }
          : a
      )
    );
    setEditAdmin(null);
    setViewAdmin(null);
  };

  const handleEditSave = (updated) => {
    setSubAdmins((prev) =>
      prev.map((a) => (a.id === updated.id ? { ...a, ...updated } : a))
    );
    setEditAdmin(null);
  };

  const handleDelete = (admin) => {
    if (window.confirm(`Remove sub-admin "${admin.name}"?`)) {
      setSubAdmins((prev) => prev.filter((a) => a.id !== admin.id));
      setViewAdmin(null);
      setEditAdmin(null);
    }
  };

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Sub Admin Management</span>
          </p>
          <h1 className="dashboard-hero__title">Sub Admin Management</h1>
          <p className="dashboard-hero__subtitle">
            Manage sub-admin accounts and permissions
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-user-friends" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="dashboard-activity-section">
          <div className="dashboard-activity-header dashboard-activity-header--with-action">
            <div className="dashboard-activity-header__left">
              <div className="dashboard-activity-header__icon">
                <i className="fas fa-redo" />
              </div>
              <h2 className="dashboard-activity-header__title">Sub Admin Management</h2>
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleOpenModal}
            >
              <i className="fas fa-plus" />
              Add Sub Admin
            </button>
          </div>
          <div className="dashboard-content-inner">
            <div className="table-wrap subadmin-table-wrap">
              <table className="data-table subadmin-table">
                <thead>
                  <tr>
                    {columns.map((col) => (
                      <th key={col.key}>{col.label}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {subAdmins.map((row) => (
                    <tr key={row.id}>
                      {columns.map((col) => {
                        if (col.key === "actions") {
                          return (
                            <td key={col.key} className="subadmin-table__actions">
                              <button
                                type="button"
                                className="btn-icon btn-icon--view"
                                onClick={() => setViewAdmin(row)}
                                title="View details"
                              >
                                <i className="fas fa-eye" />
                              </button>
                              <button
                                type="button"
                                className="btn-icon btn-icon--edit"
                                onClick={() => setEditAdmin(row)}
                                title="Edit"
                              >
                                <i className="fas fa-edit" />
                              </button>
                              <button
                                type="button"
                                className={`btn-icon btn-icon--block ${
                                  row.status === "Active" ? "" : "btn-icon--unblock"
                                }`}
                                onClick={() => handleBlockToggle(row)}
                                title={row.status === "Active" ? "Block" : "Unblock"}
                              >
                                <i
                                  className={
                                    row.status === "Active"
                                      ? "fas fa-ban"
                                      : "fas fa-check-circle"
                                  }
                                />
                              </button>
                              <button
                                type="button"
                                className="btn-icon btn-icon--delete"
                                onClick={() => handleDelete(row)}
                                title="Delete"
                              >
                                <i className="fas fa-trash-alt" />
                              </button>
                            </td>
                          );
                        }
                        if (col.key === "status") {
                          return (
                            <td key={col.key}>
                              <span
                                className={`badge badge--${
                                  row.status === "Active" ? "active" : "inactive"
                                }`}
                              >
                                {row[col.key]}
                              </span>
                            </td>
                          );
                        }
                        if (col.key === "roles") {
                          return (
                            <td key={col.key} className="subadmin-table__roles">
                              {getRolesDisplay(row)}
                            </td>
                          );
                        }
                        return <td key={col.key}>{row[col.key]}</td>;
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>

      {/* Add Sub Admin modal */}
      {modalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Add Sub Admin</h3>
              <button
                type="button"
                className="modal-close"
                onClick={handleCloseModal}
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <form onSubmit={handleAddSubmit} className="modal-body">
              {error && <div className="modal-error">{error}</div>}
              <div className="modal-field">
                <label>Name</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Full name"
                  autoComplete="name"
                />
              </div>
              <div className="modal-field">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="admin@example.com"
                  autoComplete="email"
                />
              </div>
              <div className="modal-field">
                <label>Roles (select multiple)</label>
                <div className="roles-checkbox-group">
                  {ROLES.map((r) => (
                    <label key={r} className="roles-checkbox-label">
                      <input
                        type="checkbox"
                        checked={form.roles.includes(r)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setForm((prev) => ({
                            ...prev,
                            roles: checked
                              ? [...prev.roles, r]
                              : prev.roles.filter((x) => x !== r),
                          }));
                          setError("");
                        }}
                      />
                      <span>{r}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div className="modal-field">
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Min 6 characters"
                  autoComplete="new-password"
                />
              </div>
              <div className="modal-field">
                <label>Confirm Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  placeholder="Re-enter password"
                  autoComplete="new-password"
                />
              </div>
              <div className="modal-field">
                <label>Status</label>
                <select name="status" value={form.status} onChange={handleChange}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Create Sub Admin
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View modal */}
      {viewAdmin && (
        <div className="modal-overlay" onClick={() => setViewAdmin(null)}>
          <div className="modal modal--md" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Sub Admin Details</h3>
              <button
                type="button"
                className="modal-close"
                onClick={() => setViewAdmin(null)}
                aria-label="Close"
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <dl className="detail-list">
                <div className="detail-list__row">
                  <dt>Name</dt>
                  <dd>{viewAdmin.name}</dd>
                </div>
                <div className="detail-list__row">
                  <dt>Email</dt>
                  <dd>{viewAdmin.email}</dd>
                </div>
                <div className="detail-list__row">
                  <dt>Roles</dt>
                  <dd>{getRolesDisplay(viewAdmin)}</dd>
                </div>
                <div className="detail-list__row">
                  <dt>Status</dt>
                  <dd>
                    <span
                      className={`badge badge--${
                        viewAdmin.status === "Active" ? "active" : "inactive"
                      }`}
                    >
                      {viewAdmin.status}
                    </span>
                  </dd>
                </div>
                <div className="detail-list__row">
                  <dt>Created</dt>
                  <dd>{viewAdmin.created}</dd>
                </div>
              </dl>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setViewAdmin(null)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    setEditAdmin(viewAdmin);
                    setViewAdmin(null);
                  }}
                >
                  <i className="fas fa-edit" /> Edit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit modal */}
      {editAdmin && (
        <EditSubAdminModal
          admin={editAdmin}
          onSave={handleEditSave}
          onClose={() => setEditAdmin(null)}
        />
      )}
    </main>
  );
};

const EditSubAdminModal = ({ admin, onSave, onClose }) => {
  const adminRoles = admin.roles || (admin.role ? [admin.role] : []);
  const [form, setForm] = useState({
    name: admin.name,
    email: admin.email,
    roles: Array.isArray(adminRoles) ? [...adminRoles] : [adminRoles],
    status: admin.status,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.roles || form.roles.length === 0) return;
    onSave({ ...admin, ...form, roles: form.roles });
  };

  const toggleRole = (r) => {
    setForm((p) => ({
      ...p,
      roles: p.roles.includes(r)
        ? p.roles.filter((x) => x !== r)
        : [...p.roles, r],
    }));
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Edit Sub Admin</h3>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <i className="fas fa-times" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          <div className="modal-field">
            <label>Name</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))}
              required
            />
          </div>
          <div className="modal-field">
            <label>Email</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))}
              required
            />
          </div>
          <div className="modal-field">
            <label>Roles (select multiple)</label>
            <div className="roles-checkbox-group">
              {ROLES.map((r) => (
                <label key={r} className="roles-checkbox-label">
                  <input
                    type="checkbox"
                    checked={form.roles.includes(r)}
                    onChange={() => toggleRole(r)}
                  />
                  <span>{r}</span>
                </label>
              ))}
            </div>
          </div>
          <div className="modal-field">
            <label>Status</label>
            <select
              value={form.status}
              onChange={(e) => setForm((p) => ({ ...p, status: e.target.value }))}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SubAdminPage;
